import {useParams} from '@aboutyou/router';

export const useGetActiveSectionId = () => {
  // In case the section slug has a '-' (e.g. /h/shipping-service-4401167846556),
  // the params may be captured as split parts, producing an invalid sectionId.
  //
  // This could lead to an unknown sectionId and return 404.
  const params = useParams<{sectionId?: `${string}${number}`}>();

  return parseFloat((params?.sectionId || '').replace(/\D*/, ''));
};
